// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/bg-main-1-parallax.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/img/bg-main-2-parallax.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/img/bg-main-3-parallax.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/img/bg-main-4-parallax.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/img/img-part-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/img/about-us-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/img/about-us-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/img/about-us-3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/img/bg-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/img/image11.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/img/bg-thanks.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23ffffff%27 d=%27M10.293 3.293L6 7.586 1.707 3.293A1 1 0 00.293 4.707l5 5a1 1 0 001.414 0l5-5a1 1 0 10-1.414-1.414z%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Red+Hat+Display:ital,wght@0,300..900;1,300..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Red Hat Display", sans-serif;
}

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(49, 53, 59, 0.8117647059);
  overscroll-behavior: none;
  width: 100vw;
  overflow-x: hidden;
}

ul {
  padding-left: 1rem;
}

.main-layout-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.main-layout-container--interview {
  min-height: 100vh;
  overflow: hidden;
  background: #0a0c12;
}

.text-brand {
  color: #12b7ad;
}

.text-brand2 {
  color: #F7C154;
}

.text-right {
  text-align: right;
}

.form-check-input:checked {
  background-color: #12b7ad;
  border-color: #12b7ad;
}

.form-check-input:focus {
  box-shadow: 0 0 0 0.25rem rgba(18, 183, 173, 0.25);
}

.header {
  font-weight: 900;
  font-size: 2rem;
  line-height: 2.7rem;
}

.subheader {
  font-weight: 600;
  font-size: 1.6rem;
}

.title {
  font-weight: 400;
  font-size: 1.2rem;
}

.text-inactive {
  color: #a0a9b1 !important;
}

.css-t3ipsp-control {
  box-shadow: none !important;
  border-color: #12b7ad !important;
}

.css-t3ipsp-control:hover {
  border-color: #12b7ad !important;
}

.pointer {
  cursor: pointer;
}

.btn-brand {
  background-color: #12b7ad !important;
  color: white !important;
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.btn-outline-brand {
  border-color: #12b7ad !important;
  color: #12b7ad !important;
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.btn-scroll-wrap {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 2;
  width: auto;
  height: auto;
}
.btn-scroll-wrap .btn-scroll {
  cursor: pointer;
  width: 50px;
  height: 50px;
  background-color: #fff;
  border-radius: 50%;
  text-align: center;
  box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.4);
  -webkit-box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.4);
  -moz-box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.4);
  margin: auto;
  margin-bottom: 5px;
  position: relative;
}
.btn-scroll-wrap .btn-scroll svg {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #12b7ad;
}
.btn-scroll-wrap .txt {
  font-size: 0.7rem;
  color: #5C5C5C;
  text-align: center;
}

.outlet-wrapper {
  padding-top: 106px;
  flex: 1 1 auto;
}
.outlet-wrapper--interview {
  padding-top: 0;
  min-height: 100vh;
}
.outlet-wrapper--interview-fullscreen {
  overflow: hidden;
  background: #0a0c12;
}

@keyframes logoNav {
  0% {
    height: 80px;
  }
  100% {
    height: 40px;
  }
}
@keyframes logoNavIddle {
  0% {
    height: 40px;
  }
  100% {
    height: 80px;
  }
}
.navbar {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(9.7px);
  -webkit-backdrop-filter: blur(9.7px);
}
.navbar .logo {
  height: 80px;
}
.navbar .nav-link {
  font-weight: 600;
  font-weight: bold;
  color: rgba(52, 58, 64, 0.9019607843);
}
.navbar .nav-link:hover {
  color: #12b7ad;
}
.navbar .nav-link.active {
  color: #12b7ad;
}
.navbar .btn-login {
  background-color: #12b7ad !important;
  color: #fff !important;
  padding: 6px 18px !important;
  border-radius: 8px;
  font-weight: 600;
  margin-left: 10px;
}
.navbar .btn-login:hover {
  background-color: #0e928a !important;
  color: #fff !important;
}
.navbar .navbar-toggler {
  padding: 10px;
}

.naviddle .navbar .logo {
  animation-duration: 0.5s;
  animation-name: logoNavIddle;
  animation-timing-function: ease-out;
  height: 80px;
}

.navresize .navbar {
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.navresize .navbar .logo {
  animation-duration: 0.5s;
  animation-name: logoNav;
  animation-timing-function: ease-out;
  height: 40px;
}

.profile-menu-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.profile-menu-wrapper .profile-picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #12b7ad;
  transition: all 0.3s ease;
}
.profile-menu-wrapper .profile-picture:hover {
  box-shadow: 0 2px 8px rgba(18, 183, 173, 0.3);
  transform: scale(1.05);
}
.profile-menu-wrapper .profile-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  margin-top: 8px;
  z-index: 1000;
  animation: slideDown 0.3s ease-out;
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.profile-menu-wrapper .profile-dropdown .profile-dropdown__item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px 8px 0 0;
}
.profile-menu-wrapper .profile-dropdown .profile-dropdown__item:hover {
  background-color: #f0fffe;
  color: #12b7ad;
}
.profile-menu-wrapper .profile-dropdown .profile-dropdown__item svg {
  width: 18px;
  height: 18px;
}
.profile-menu-wrapper .profile-dropdown .logout-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  color: #ff6b6b;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
}
.profile-menu-wrapper .profile-dropdown .logout-btn:hover {
  background-color: #fff5f5;
  color: #ff5252;
}
.profile-menu-wrapper .profile-dropdown .logout-btn svg {
  width: 18px;
  height: 18px;
}

.main-content, .talent-content {
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.main-content .main-parallax-1, .talent-content .main-parallax-1 {
  position: absolute;
  bottom: -30px;
  right: 0px;
  width: 550px;
  height: 550px;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 0;
}
.main-content .main-parallax-2, .talent-content .main-parallax-2 {
  position: absolute;
  bottom: 30px;
  right: 0px;
  width: 550px;
  height: 550px;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
}
.main-content .main-parallax-3, .talent-content .main-parallax-3 {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 550px;
  height: 550px;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
}
.main-content .content-wrapper, .talent-content .content-wrapper {
  max-width: 550px;
  z-index: 2;
}
.main-content .content-wrapper .subtitle, .talent-content .content-wrapper .subtitle {
  font-weight: 900;
  color: #F7C154;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.main-content .content-wrapper .title, .talent-content .content-wrapper .title {
  font-weight: 900;
  color: #12b7ad;
  font-size: 2.6rem;
  margin-top: 15px;
  line-height: 2.8rem;
}
.main-content .content-wrapper .desc, .talent-content .content-wrapper .desc {
  margin-top: 15px;
  font-size: 1rem;
  font-weight: 600;
}

.talent-content {
  height: 70vh;
}
.talent-content .main-parallax-4 {
  position: absolute;
  bottom: -100px;
  right: 0px;
  width: 550px;
  height: 550px;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
}
.talent-content .main-parallax-2 {
  bottom: -100px;
}

.bg-brand-opacity {
  background-color: #f1faf9;
}

.bg-brand {
  background-color: #12b7ad;
}

.text-wrap {
  text-wrap: wrap !important;
}

.flex-1 {
  min-width: 0;
  flex: 1 1 !important;
}

.card {
  border: 1px solid #eee;
}
.card.no-border {
  border-width: 0px !important;
}

.shadow {
  box-shadow: -3px 3px 28px -4px rgba(148, 148, 148, 0.4) !important;
  -webkit-box-shadow: -3px 3px 28px -4px rgba(148, 148, 148, 0.4) !important;
  -moz-box-shadow: -3px 3px 28px -4px rgba(148, 148, 148, 0.4) !important;
}

.slick-track,
.slick-list {
  width: 100%;
  min-width: 100%;
}

.slick-dots li button::before {
  font-size: 18px;
}

.slick-dots li.slick-active button::before {
  color: #12b7ad;
}

.about-us {
  position: relative;
  z-index: 2;
}
.about-us::after {
  content: "";
  width: 200px;
  height: 140px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  top: 0;
}
.about-us .about-us-image-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
.about-us .about-us-parallax-1 {
  position: absolute;
  top: 0;
  left: -30px;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 0;
}
.about-us .about-us-parallax-2 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
}
.about-us .about-us-parallax-3 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: contain;
  background-repeat: no-repeat;
}

.talent-list-wrapper {
  position: relative;
  z-index: 2;
  background-color: #f1faf9;
}

.talent-list img {
  width: 30%;
  height: 30%;
  border-radius: 10px;
  object-fit: cover;
}

input:focus, textarea:focus {
  border-color: #12b7ad !important;
  box-shadow: none !important;
  outline: none !important;
}

.daterangepicker td.in-range {
  background-color: #cce8e6 !important;
}

.daterangepicker td.available {
  color: #0f172a;
  font-weight: 600;
  transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.daterangepicker td.available:hover {
  background-color: rgba(46, 196, 182, 0.14) !important;
  color: #12b7ad !important;
  box-shadow: inset 0 0 0 1px rgba(46, 196, 182, 0.28);
}

.daterangepicker td.off.disabled,
.daterangepicker td.disabled,
.daterangepicker option.disabled {
  color: #c3cdd8 !important;
  background-color: #fff !important;
  text-decoration: none !important;
  opacity: 1;
  cursor: not-allowed;
}

.daterangepicker .drp-buttons .btn-primary {
  background-color: #12b7ad;
  border-color: #12b7ad;
}

.daterangepicker td.active {
  background-color: #12b7ad !important;
  color: #fff !important;
  font-weight: 700;
  box-shadow: 0 8px 20px rgba(46, 196, 182, 0.24);
}

.image-uploader-container {
  width: 100%;
  position: relative;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
}
.image-uploader-container .image-uploader-bg {
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  background: #cce8e6;
}
.image-uploader-container .image-uploader-bg.singleback {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  filter: blur(34px);
  background: #cce8e6;
}
.image-uploader-container img {
  position: absolute;
  height: 100%;
  width: auto;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.input-tag-wrapper .ReactTags__tags {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.input-tag-wrapper .ReactTags__tagInput {
  flex: 1 1;
}
.input-tag-wrapper .ReactTags__tagInput input {
  width: 100%;
  padding: 0.375rem 0.75rem;
  display: block;
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input-tag-wrapper .ReactTags__tagInput input:focus {
  border-color: #12b7ad !important;
  box-shadow: none !important;
  outline: none !important;
}
.input-tag-wrapper .ReactTags__selected {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.input-tag-wrapper .ReactTags__selected span.ReactTags__tag {
  background: #12b7ad;
  color: white;
  font-size: 12px;
  display: flex;
  padding: 5px;
  border-radius: 3px;
}
.input-tag-wrapper .ReactTags__selected a.ReactTags__remove {
  color: #aaa;
  margin-left: 5px;
  cursor: pointer;
}
.input-tag-wrapper .ReactTags__remove {
  border: none;
  cursor: pointer;
  background: none;
  color: white;
  margin-right: -5px;
}
.input-tag-wrapper .ReactTags__remove svg {
  width: 9px;
  height: 9px;
  margin-top: -3px;
}

.css-1p3m7a8-multiValue {
  background-color: #12b7ad !important;
  color: #fff !important;
}
.css-1p3m7a8-multiValue .css-9jq23d {
  color: #fff !important;
}

.service-list .list {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}
.service-list .list svg {
  width: 1.8rem;
  height: 1.8rem;
  color: #F7C154;
}
.service-list .list .desc {
  font-weight: bold;
  font-size: 1.3rem;
}

.arrow-service {
  width: 40px;
  height: 40px;
  background-color: #12b7ad;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.arrow-service.disabled {
  background-color: #fff;
  border: 2px solid rgba(18, 183, 173, 0.4);
  cursor: default;
}
.arrow-service.disabled svg {
  color: rgba(18, 183, 173, 0.4);
}
.arrow-service svg {
  color: #fff;
  width: 20px;
  height: 20px;
}

.service .bg-service {
  width: 100%;
  position: relative;
}
.service .bg-service::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: -25px;
  height: 150px;
  background-color: #F7C154;
  z-index: -1;
  border-radius: 10px;
}

.product {
  background-color: rgba(247, 193, 84, 0.2);
  border-radius: 20px;
  position: relative;
}
.product .video-parallax-2 {
  position: absolute;
  bottom: 300px;
  right: -100px;
  width: 350px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  z-index: -1;
}
.product .video-parallax-3 {
  position: absolute;
  bottom: 150px;
  left: -180px;
  width: 350px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  z-index: -1;
}

.video-wrapper {
  border-radius: 20px;
  overflow: hidden;
  margin: auto;
}
.video-wrapper video {
  width: 80%;
  border-radius: 20px;
  height: auto;
  overflow: hidden;
}

.partner-list img {
  width: 60%;
  height: 80px;
  object-fit: contain;
  margin: auto;
}

.partner-logo-wrapper {
  height: 80px;
  display: flex;
  justify-content: center;
}
.partner-logo-wrapper img {
  height: 100%;
  width: 60%;
  object-fit: contain;
}

.bg-call-us {
  width: 100%;
  height: 250px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.company-detail {
  margin-top: -150px;
}

.form-detail {
  margin-top: -70px;
}

.for-talent-wrapper {
  background-color: #12b7ad;
  color: #fff;
  overflow: hidden;
}
.for-talent-wrapper hr {
  height: 2px;
  background: #fff !important;
}

.img-for-talent {
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: cover;
  background-position: center;
}

.footer {
  background-color: #12b7ad;
  border-top: 1px solid #fff;
}
.footer .hr {
  width: 100%;
  height: 1px;
  background-color: #fff;
}
.footer a {
  color: #fff;
}

.thank-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: cover;
  background-position: 50% center;
  background-repeat: no-repeat;
  min-height: 100vh;
  height: auto;
  margin-top: -106px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: clamp(132px, 16vh, 180px) 0 clamp(42px, 7vh, 72px);
}
.thank-container .container {
  width: min(100%, clamp(600px, 42vw, 700px));
  max-width: none;
}

.thank-shell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(16px, 1.8vh, 20px);
  width: 100%;
  max-width: min(100%, 680px);
  margin: 0 auto;
  transform: translateX(clamp(-20px, -1.15vw, -10px));
}
.thank-shell__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(18, 184, 134, 0.12);
  color: #12b7ad;
  font-size: 0.92rem;
  font-weight: 700;
}
.thank-shell__eyebrow svg {
  width: 16px;
  height: 16px;
}
.thank-shell__heading {
  font-size: clamp(2.35rem, 3.4vw, 4rem);
  font-weight: 900;
  line-height: 1.08;
  margin: 0;
  max-width: 100%;
  text-wrap: balance;
}
.thank-shell__subtitle {
  font-size: clamp(1rem, 1.15vw, 1.1rem);
  line-height: 1.65;
  color: #495057;
  max-width: 34rem;
  margin: 0;
  text-wrap: balance;
}
.thank-shell__secondary-cta {
  margin-top: 4px;
  min-width: 220px;
  border-width: 1.5px !important;
  background: rgba(255, 255, 255, 0.82) !important;
}

.thank-next-step-card {
  width: 100%;
  margin-top: 8px;
  padding: clamp(24px, 2.4vw, 30px) clamp(22px, 2.6vw, 30px) clamp(22px, 2.1vw, 26px);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(18, 184, 134, 0.16);
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  text-align: left;
}
.thank-next-step-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.12);
  color: #0f9b6c;
  font-size: 0.84rem;
  font-weight: 800;
  margin-bottom: 18px;
}
.thank-next-step-card__header {
  display: flex;
  align-items: flex-start;
  gap: clamp(14px, 1.4vw, 18px);
}
.thank-next-step-card__icon {
  width: 54px;
  height: 54px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(18, 184, 134, 0.16), rgba(255, 196, 62, 0.18));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #12b7ad;
  flex-shrink: 0;
}
.thank-next-step-card__icon svg {
  width: 24px;
  height: 24px;
}
.thank-next-step-card__copy {
  flex: 1 1;
  min-width: 0;
}
.thank-next-step-card__title {
  font-size: clamp(1.34rem, 1.45vw, 1.52rem);
  font-weight: 800;
  color: #102a43;
  margin-bottom: 8px;
  line-height: 1.22;
}
.thank-next-step-card__description {
  font-size: clamp(0.98rem, 1vw, 1.02rem);
  line-height: 1.65;
  color: #52606d;
  margin: 0;
}
.thank-next-step-card__meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(148px, 1fr));
  gap: 10px;
  margin-top: 22px;
  margin-bottom: 22px;
}
.thank-next-step-card__meta-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 52px;
  padding: 12px 14px;
  border-radius: 16px;
  background: #f8fbfc;
  border: 1px solid rgba(148, 163, 184, 0.18);
  color: #334e68;
  font-size: 0.92rem;
  line-height: 1.45;
}
.thank-next-step-card__meta-item svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #12b7ad;
}
.thank-next-step-card__cta {
  width: 100%;
  min-height: 54px;
  border-radius: 16px !important;
  font-size: 1rem !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 12px 30px rgba(25, 135, 84, 0.2);
}
.thank-next-step-card__cta svg {
  width: 18px;
  height: 18px;
}

.desktop-only {
  display: block;
}

.equal-height-slider .slick-track {
  display: flex;
  align-items: stretch;
}

.equal-height-slider .slick-slide {
  height: inherit;
}

.problemsolve-wrapper {
  display: flex;
  flex-direction: row;
  align-items: stretch; /* Key property */
  border-radius: 15px;
  overflow: hidden;
}
.problemsolve-wrapper ul {
  font-size: 1.3rem;
}
.problemsolve-wrapper .problem {
  flex: 1 1;
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px 20px;
  line-height: 2.5rem;
}
.problemsolve-wrapper .solve {
  flex: 1.4 1;
  background-color: #d4edda;
  color: #155724;
  padding: 10px 20px 10px 70px;
  line-height: 2.5rem;
}

.bot-wa {
  position: fixed;
  z-index: 9;
  bottom: 6px;
  right: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.bot-wa .img-bot {
  width: 100px;
}
.bot-wa .wa-bubble {
  position: relative;
  background-color: #ffffff;
  padding: 8px 14px;
  border-radius: 30px;
  box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.6);
  -webkit-box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.6);
  -moz-box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.6);
  font-weight: 800;
  font-size: 15px;
  max-width: 170px;
  line-height: 1.4;
  display: flex;
  flex-direction: row;
  margin-top: -10px;
  align-items: center;
}
.bot-wa .wa-bubble::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -5px;
  width: 12px;
  height: 12px;
  background-color: #ffffff;
  transform: translateY(-50%) rotate(45deg);
  box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.18);
}
.bot-wa .wa-bubble .wa-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
}

@media (max-width: 820px) {
  body {
    width: 100%;
  }
  .headerMain .navbar .container {
    width: 100%;
    max-width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }
  .headerMain .navbar .navbar-brand {
    flex: 0 0 auto;
    margin-right: 12px;
  }
  .headerMain .navbar .navbar-toggler {
    flex: 0 0 auto;
    margin-left: auto;
  }
  .bot-wa {
    right: 4px;
    bottom: 4px;
  }
  .bot-wa .wa-bubble {
    display: none;
  }
  .bot-wa .img-bot {
    width: 58px;
    height: auto;
  }
}
@media (max-width: 360px) {
  .headerMain .navbar .container {
    padding-left: 10px;
    padding-right: 10px;
  }
}
/* ==== START MEDIA QUERY ====*/
@media only screen and (min-width: 991px) and (max-width: 1400px) {
  .main-parallax-1 {
    width: 39vw !important;
    height: 39vw !important;
  }
  .main-parallax-2 {
    width: 39vw !important;
    height: 39vw !important;
  }
  .main-parallax-3 {
    width: 39vw !important;
    height: 39vw !important;
  }
  .content-wrapper {
    max-width: 40vw !important;
  }
  .app-talent.container {
    max-width: 100%;
    margin-left: 3rem;
  }
}
@media only screen and (max-width: 991px) {
  .navbar .logo {
    height: 50px !important;
  }
  .desktop-only {
    display: none !important;
  }
  .main-parallax-1 {
    width: 500px !important;
    height: 500px !important;
    right: -220px !important;
  }
  .main-parallax-2 {
    width: 500px !important;
    height: 500px !important;
    right: -220px !important;
  }
  .main-parallax-3 {
    width: 500px !important;
    height: 500px !important;
    right: -220px !important;
  }
  .content-wrapper {
    max-width: 50vw !important;
  }
  .video-wrapper video {
    width: 100%;
    height: auto;
  }
  .video-parallax-2 {
    right: -180px !important;
    width: 300px !important;
    height: 300px !important;
  }
  .video-parallax-3 {
    left: -280px !important;
    width: 350px !important;
    height: 350px !important;
  }
}
@media (max-height: 860px) and (min-width: 1024px) {
  .thank-container {
    padding-top: 116px;
    padding-bottom: 36px;
  }
  .thank-shell {
    gap: 14px;
  }
  .thank-shell__heading {
    font-size: clamp(2.15rem, 3vw, 3.2rem);
  }
  .thank-shell__subtitle {
    line-height: 1.58;
  }
  .thank-next-step-card {
    padding: 22px 22px 20px;
  }
  .thank-next-step-card__meta {
    margin-top: 18px;
    margin-bottom: 18px;
  }
}
@media only screen and (max-width: 768px) {
  .thank-container {
    min-height: 100vh;
    height: auto;
    padding: 120px 0 32px;
    background-position: center top;
  }
  .thank-container .container {
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }
  .thank-shell {
    gap: 14px;
    transform: none;
  }
  .thank-shell__heading {
    font-size: 1.95rem;
    line-height: 1.18;
  }
  .thank-shell__subtitle {
    font-size: 1rem;
    line-height: 1.6;
  }
  .thank-shell__secondary-cta {
    width: 100%;
    min-height: 48px;
  }
  .thank-next-step-card {
    padding: 22px 18px 18px;
    border-radius: 20px;
  }
  .thank-next-step-card__header {
    gap: 14px;
  }
  .thank-next-step-card__icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
  }
  .thank-next-step-card__title {
    font-size: 1.22rem;
  }
  .thank-next-step-card__description {
    font-size: 0.96rem;
    line-height: 1.62;
  }
  .thank-next-step-card__meta {
    grid-template-columns: 1fr;
    gap: 8px;
    margin-top: 18px;
    margin-bottom: 18px;
  }
  .thank-next-step-card__meta-item {
    min-height: 0;
  }
  .thank-next-step-card__cta {
    min-height: 50px;
  }
  .text-center-mobile {
    text-align: center;
  }
  .desktop-only {
    display: none !important;
  }
  .main-content .title {
    font-size: 1.5rem !important;
    line-height: 1.8rem !important;
  }
  .main-parallax-1 {
    right: -250px !important;
    transform: scaleX(-1) !important;
  }
  .main-parallax-2, .main-parallax-3 {
    right: -350px !important;
    transform: scaleX(-1) !important;
  }
  .talent-content .content-wrapper {
    max-width: 70vw !important;
  }
  .talent-content .main-parallax-4 {
    right: -220px !important;
    transform: scaleX(-1) !important;
  }
  .video-wrapper video {
    width: 100%;
    height: auto;
  }
  .for-talent-wrapper .ms-5 {
    margin-left: 0px !important;
  }
  .form-detail {
    margin-top: 40px;
  }
}
.register-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  padding: 20px;
  position: relative;
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.register-container::before {
  content: none;
}

.register-container .register-card {
  width: 100%;
  max-width: 500px;
  background: #ffffff;
  -webkit-backdrop-filter: none;
          backdrop-filter: none;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  padding: 50px 40px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.1);
  animation: slideUp 0.8s ease-out;
  position: relative;
  z-index: 10;
}
@media (max-width: 480px) {
  .register-container .register-card {
    padding: 40px 25px;
    max-width: 100%;
  }
}

.register-container .register-header {
  text-align: center;
  margin-bottom: 40px;
}
.register-container .register-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #0b2540;
  margin: 0 0 10px 0;
  text-shadow: none;
  letter-spacing: -0.5px;
}
.register-container .register-header p {
  font-size: 14px;
  color: #54708b;
  margin: 0;
  font-weight: 500;
}

.register-container .register-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.register-container .register-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.register-container .register-form .form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #17324d;
  text-shadow: none;
}
.register-container .register-form .form-group .error-message {
  font-size: 12px;
  color: #ff6b6b;
  font-weight: 500;
  margin-top: 4px;
  animation: shake 0.3s ease-in-out;
}
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}
.register-container .register-form .form-group .alert {
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
  animation: slideDown 0.3s ease-out;
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.register-container .register-form .form-group .alert.alert-error {
  background: rgba(255, 107, 107, 0.2);
  border: 1px solid rgba(255, 107, 107, 0.5);
  color: #ff6b6b;
}
.register-container .register-form .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
@media (max-width: 480px) {
  .register-container .register-form .form-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.register-container .form-input {
  padding: 14px 16px;
  background: #ffffff !important;
  border: 1.5px solid #d7e0e8;
  border-radius: 12px;
  font-size: 14px;
  color: #102a43 !important;
  font-family: inherit;
  transition: all 0.3s ease;
  outline: none;
}
.register-container .form-input::-ms-reveal {
  display: none;
}
.register-container .form-input::placeholder {
  color: #89a0b7 !important;
  font-weight: 500 !important;
  opacity: 1 !important;
}
.register-container .form-input::-webkit-input-placeholder {
  color: #89a0b7 !important;
  font-weight: 500 !important;
  opacity: 1 !important;
}
.register-container .form-input::-moz-placeholder {
  color: #89a0b7 !important;
  font-weight: 500 !important;
  opacity: 1 !important;
}
.register-container .form-input:-ms-input-placeholder {
  color: #89a0b7 !important;
  font-weight: 500 !important;
  opacity: 1 !important;
}
.register-container .form-input::-moz-placeholder {
  opacity: 1 !important;
}
.register-container .form-input:focus {
  background: #ffffff !important;
  border-color: rgba(18, 183, 173, 0.65);
  box-shadow: 0 0 0 3px rgba(18, 183, 173, 0.14);
}
.register-container .form-input.error {
  border-color: #ff6b6b;
  background: rgba(255, 107, 107, 0.1);
  animation: shake 0.3s ease-in-out;
}
.register-container .form-input.error:focus {
  box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.2);
}
.register-container .form-input select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
}
.register-container .form-input option {
  background: #667eea;
  color: white;
  padding: 10px;
}
.register-container .form-input option:hover {
  background: #764ba2;
}

.register-container .password-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.register-container .password-wrapper .form-input {
  flex: 1 1;
  padding-right: 48px;
}
.register-container .password-wrapper .password-toggle {
  position: absolute;
  right: 12px;
  bottom: 12px;
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  font-size: 16px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  line-height: 1;
}
.register-container .password-wrapper .password-toggle:hover {
  color: #0d8a84;
}
.register-container .password-wrapper .password-toggle:active {
  opacity: 0.8;
}
.register-container .password-wrapper .password-toggle svg {
  width: 16px;
  height: 16px;
}

.register-container .password-criteria {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  margin-top: 8px;
  animation: slideDown 0.3s ease-out;
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.register-container .password-criteria .criteria-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
  transition: all 0.3s ease;
}
.register-container .password-criteria .criteria-item .criteria-icon {
  width: 14px;
  height: 14px;
  stroke-width: 3;
  color: #94a3b8;
  flex-shrink: 0;
}
.register-container .password-criteria .criteria-item.met {
  color: #17324d;
}
.register-container .password-criteria .criteria-item.met .criteria-icon {
  color: rgb(34, 197, 94);
  animation: checkBounce 0.5s ease-out;
}
@keyframes checkBounce {
  0% {
    transform: scale(0) rotate(-45deg);
    opacity: 0;
  }
  50% {
    transform: scale(1.2) rotate(10deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}

.register-container .submit-button {
  padding: 14px 16px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
}
.register-container .submit-button.active {
  background: linear-gradient(135deg, #12b7ad 0%, #0d8a84 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(18, 183, 173, 0.3);
}
.register-container .submit-button.active:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(18, 183, 173, 0.4);
}
.register-container .submit-button.active:active {
  transform: translateY(0);
}
.register-container .submit-button.disabled {
  background: rgba(142, 161, 180, 0.28);
  color: rgba(23, 50, 77, 0.48);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}
.register-container .submit-button:disabled {
  pointer-events: auto;
  cursor: not-allowed;
}

.register-container .login-link {
  text-align: center;
  margin-top: 24px;
  font-size: 14px;
  color: #54708b;
}
.register-container .login-link a {
  color: #0d8a84;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.register-container .login-link a:hover {
  color: #0a726d;
  border-bottom-color: #0a726d;
  text-shadow: none;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .register-card {
    border-radius: 16px;
  }
  .register-header h1 {
    font-size: 28px;
  }
}
@media (max-width: 500px) {
  .register-container {
    padding: 16px;
  }
  .register-card {
    padding: 32px 20px;
  }
  .register-header {
    margin-bottom: 32px;
  }
  .register-header h1 {
    font-size: 24px;
  }
  .register-header p {
    font-size: 13px;
  }
  .form-input {
    font-size: 16px;
  }
  .form-input::placeholder {
    font-size: 13px;
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/_theme.scss","webpack://./src/scss/register.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACI,0CAAA;ACAJ;;ADGA;EACI,SAAA;EACA,mCAAA;EACA,kCAAA;EACA,qCEPS;EFQT,yBAAA;EACA,YAAA;EACA,kBAAA;ACAJ;;ADGA;EACI,kBAAA;ACAJ;;ADGA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;ACAJ;ADEI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;ACAR;;ADIA;EACI,cElCU;ADiCd;;ADIA;EACI,cErCW;ADoCf;;ADIA;EACI,iBAAA;ACDJ;;ADMA;EACI,yBEhDU;EFiDV,qBEjDU;AD8Cd;;ADMA;EACI,kDAAA;ACHJ;;ADMA;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;ACHJ;;ADMA;EACI,gBAAA;EACA,iBAAA;ACHJ;;ADMA;EACI,gBAAA;EACA,iBAAA;ACHJ;;ADMA;EACI,yBAAA;ACHJ;;ADMA;EACI,2BAAA;EACA,gCAAA;ACHJ;;ADMA;EACI,gCAAA;ACHJ;;ADMA;EACI,eAAA;ACHJ;;ADMA;EACI,oCAAA;EACA,uBAAA;EACA,6BAAA;EACA,8BAAA;ACHJ;;ADMA;EACI,gCAAA;EACA,yBAAA;EACA,6BAAA;EACA,8BAAA;ACHJ;;ADMA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;ACHJ;ADKI;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wDAAA;EACA,gEAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ACHR;ADKQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,cEpIE;ADiId;ADOI;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;ACLR;;ADSA;EACI,kBAAA;EACA,cAAA;ACNJ;ADQI;EACI,cAAA;EACA,iBAAA;ACNR;ADSI;EACI,gBAAA;EACA,mBAAA;ACPR;;ADYA;EACI;IACI,YAAA;ECTN;EDWE;IACI,YAAA;ECTN;AACF;ADYA;EACI;IACI,YAAA;ECVN;EDYE;IACI,YAAA;ECVN;AACF;ADaA;EACI,oCAAA;EACA,4BAAA;EACA,oCAAA;ACXJ;ADaI;EACI,YAAA;ACXR;ADcI;EACI,gBAAA;EACA,iBAAA;EACA,qCAAA;ACZR;ADcQ;EACI,cEhME;ADoLd;ADeQ;EACI,cEpME;ADuLd;ADiBI;EACI,oCAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACfR;ADiBQ;EACI,oCAAA;EACA,sBAAA;ACfZ;ADmBI;EACI,aAAA;ACjBR;;ADuBQ;EACI,wBAAA;EACA,4BAAA;EACA,mCAAA;EACA,YAAA;ACpBZ;;AD0BI;EACI,yCAAA;EACA,0CAAA;ACvBR;ADyBQ;EACI,wBAAA;EACA,uBAAA;EACA,mCAAA;EACA,YAAA;ACvBZ;;AD6BA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AC1BJ;AD4BI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;AC1BR;AD4BQ;EACI,6CAAA;EACA,sBAAA;AC1BZ;AD8BI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;AC5BR;AD8BQ;EACI;IACI,UAAA;IACA,4BAAA;EC5Bd;ED8BU;IACI,UAAA;IACA,wBAAA;EC5Bd;AACF;AD+BQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;AC7BZ;AD+BY;EACI,yBAAA;EACA,cE/SF;ADkRd;ADgCY;EACI,WAAA;EACA,YAAA;AC9BhB;ADkCQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AChCZ;ADkCY;EACI,yBAAA;EACA,cAAA;AChChB;ADmCY;EACI,WAAA;EACA,YAAA;ACjChB;;ADuCA;EACI,WAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;ACpCJ;ADsCI;EACI,kBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,UAAA;ACpCR;ADuCI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;ACrCR;ADwCI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;ACtCR;ADyCI;EACI,gBAAA;EACA,UAAA;ACvCR;ADyCQ;EACI,gBAAA;EACA,cErYG;EFsYH,iBAAA;EACA,yBAAA;ACvCZ;AD0CQ;EACI,gBAAA;EACA,cE7YE;EF8YF,iBAAA;EACA,gBAAA;EACA,mBAAA;ACxCZ;AD2CQ;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;ACzCZ;;AD8CA;EACI,YAAA;AC3CJ;AD6CI;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AC3CR;AD8CI;EACI,cAAA;AC5CR;;ADgDA;EACI,yBAAA;AC7CJ;;ADgDA;EACI,yBEpbU;ADuYd;;ADgDA;EACI,0BAAA;AC7CJ;;ADgDA;EACI,YAAA;EACA,oBAAA;AC7CJ;;ADgDA;EACI,sBAAA;AC7CJ;AD+CI;EACI,4BAAA;AC7CR;;ADiDA;EACI,kEAAA;EACA,0EAAA;EACA,uEAAA;AC9CJ;;ADiDA;;EAEI,WAAA;EACA,eAAA;AC9CJ;;ADmDI;EACI,eAAA;AChDR;;ADsDI;EACI,cE9dM;AD2ad;;ADuDA;EACI,kBAAA;EACA,UAAA;ACpDJ;ADsDI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;ACpDR;ADuDI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;ACrDR;ADwDI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,UAAA;ACtDR;ADyDI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;ACvDR;AD0DI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;ACxDR;;AD4DA;EACI,kBAAA;EACA,UAAA;EACA,yBAAA;ACzDJ;;AD6DI;EACI,UAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AC1DR;;AD+DI;EACI,gCAAA;EACA,2BAAA;EACA,wBAAA;AC5DR;;ADgEA;EACI,oCAAA;AC7DJ;;ADgEA;EACI,cAAA;EACA,gBAAA;EACA,gFAAA;AC7DJ;;ADgEA;EACI,qDAAA;EACA,yBAAA;EACA,oDAAA;AC7DJ;;ADgEA;;;EAGI,yBAAA;EACA,iCAAA;EACA,gCAAA;EACA,UAAA;EACA,mBAAA;AC7DJ;;ADgEA;EACI,yBEhlBU;EFilBV,qBEjlBU;ADohBd;;ADgEA;EACI,oCAAA;EACA,sBAAA;EACA,gBAAA;EACA,+CAAA;AC7DJ;;ADgEA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AC7DJ;AD+DI;EACI,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBE1mBS;AD6iBjB;ADgEQ;EACI,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBElnBK;ADojBjB;ADkEI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;AChER;;ADqEI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AClER;ADqEI;EACI,SAAA;ACnER;ADqEQ;EACI,WAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mCAAA;EACA,4BAAA;EACA,2DAAA;EACA,sCAAA;EACA,wEAAA;ACnEZ;ADqEY;EACI,gCAAA;EACA,2BAAA;EACA,wBAAA;ACnEhB;ADyEI;EACI,aAAA;EACA,QAAA;EACA,eAAA;ACvER;AD0EI;EACI,mBE7qBM;EF8qBN,YAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;ACxER;AD2EI;EACI,WAAA;EACA,gBAAA;EACA,eAAA;ACzER;AD4EI;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AC1ER;AD4EQ;EACI,UAAA;EACA,WAAA;EACA,gBAAA;AC1EZ;;AD+EA;EACI,oCAAA;EACA,sBAAA;AC5EJ;AD8EI;EACI,sBAAA;AC5ER;;ADiFI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AC9ER;ADgFQ;EACI,aAAA;EACA,cAAA;EACA,cE7tBG;AD+oBf;ADiFQ;EACI,iBAAA;EACA,iBAAA;AC/EZ;;ADoFA;EACI,WAAA;EACA,YAAA;EACA,yBE3uBU;EF4uBV,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ACjFJ;ADmFI;EACI,sBAAA;EACA,yCAAA;EACA,eAAA;ACjFR;ADmFQ;EACI,8BAAA;ACjFZ;ADqFI;EACI,WAAA;EACA,WAAA;EACA,YAAA;ACnFR;;ADwFI;EACI,WAAA;EACA,kBAAA;ACrFR;ADuFQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,yBE9wBG;EF+wBH,WAAA;EACA,mBAAA;ACrFZ;;AD0FA;EACI,yCAAA;EACA,mBAAA;EACA,kBAAA;ACvFJ;ADyFI;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,WAAA;ACvFR;AD0FI;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,WAAA;ACxFR;;AD4FA;EACI,mBAAA;EACA,gBAAA;EACA,YAAA;ACzFJ;AD2FI;EACI,UAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;ACzFR;;AD8FI;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AC3FR;;AD+FA;EACI,YAAA;EACA,aAAA;EACA,uBAAA;AC5FJ;AD8FI;EACI,YAAA;EACA,UAAA;EACA,mBAAA;AC5FR;;ADgGA;EACI,WAAA;EACA,aAAA;EACA,yDAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;AC7FJ;;ADgGA;EACI,kBAAA;AC7FJ;;ADgGA;EACI,iBAAA;AC7FJ;;ADgGA;EACI,yBEx2BU;EFy2BV,WAAA;EACA,gBAAA;AC7FJ;AD+FI;EACI,WAAA;EACA,2BAAA;AC7FR;;ADiGA;EACI,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;AC9FJ;;ADiGA;EACI,yBE33BU;EF43BV,0BAAA;AC9FJ;ADgGI;EACI,WAAA;EACA,WAAA;EACA,sBAAA;AC9FR;ADiGI;EACI,WAAA;AC/FR;;ADmGA;EACI,0DAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,2DAAA;AChGJ;ADkGI;EACI,2CAAA;EACA,eAAA;AChGR;;ADoGA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,mDAAA;ACjGJ;ADmGI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cE76BM;EF86BN,kBAAA;EACA,gBAAA;ACjGR;ADmGQ;EACI,WAAA;EACA,YAAA;ACjGZ;ADqGI;EACI,sCAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;ACnGR;ADsGI;EACI,sCAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;ACpGR;ADuGI;EACI,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,gDAAA;ACrGR;;ADyGA;EACI,WAAA;EACA,eAAA;EACA,mFAAA;EACA,mBAAA;EACA,qCAAA;EACA,0CAAA;EACA,8CAAA;EACA,kCAAA;UAAA,0BAAA;EACA,gBAAA;ACtGJ;ADwGI;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACtGR;ADyGI;EACI,aAAA;EACA,uBAAA;EACA,6BAAA;ACvGR;AD0GI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uFAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cEv/BM;EFw/BN,cAAA;ACxGR;AD0GQ;EACI,WAAA;EACA,YAAA;ACxGZ;AD4GI;EACI,SAAA;EACA,YAAA;AC1GR;AD6GI;EACI,0CAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AC3GR;AD8GI;EACI,uCAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AC5GR;AD+GI;EACI,aAAA;EACA,oDAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AC7GR;ADgHI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AC9GR;ADgHQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,cE7iCE;AD+7Bd;ADkHI;EACI,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,8CAAA;AChHR;ADkHQ;EACI,WAAA;EACA,YAAA;AChHZ;;ADqHA;EACI,cAAA;AClHJ;;ADqHA;EACE,aAAA;EACA,oBAAA;AClHF;;ADqHA;EACE,eAAA;AClHF;;ADsHA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA,EAAA,iBAAA;EACA,mBAAA;EACA,gBAAA;ACnHJ;ADqHI;EACI,iBAAA;ACnHR;ADsHI;EACI,SAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;ACpHR;ADuHI;EACI,WAAA;EACA,yBAAA;EACA,cAAA;EACA,4BAAA;EACA,mBAAA;ACrHR;;ADyHA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;ACtHF;ADwHE;EACE,YAAA;ACtHJ;ADyHE;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wDAAA;EACA,gEAAA;EACA,6DAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;ACvHJ;ADyHI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yCAAA;EACA,yDAAA;ACvHN;AD0HI;EACE,WAAA;EACA,YAAA;EACA,cAAA;ACxHN;;AD6HA;EACE;IACE,WAAA;EC1HF;ED+HI;IACE,WAAA;IACA,eAAA;IACA,kBAAA;IACA,mBAAA;EC7HN;EDgII;IACE,cAAA;IACA,kBAAA;EC9HN;EDiII;IACE,cAAA;IACA,iBAAA;EC/HN;EDoIA;IACE,UAAA;IACA,WAAA;EClIF;EDoIE;IACE,aAAA;EClIJ;EDqIE;IACE,WAAA;IACA,YAAA;ECnIJ;AACF;ADuIA;EAGM;IACE,kBAAA;IACA,mBAAA;ECvIN;AACF;AD4IA,+BAAA;AACA;EACI;IACI,sBAAA;IACA,uBAAA;EC1IN;ED6IE;IACI,sBAAA;IACA,uBAAA;EC3IN;ED8IE;IACI,sBAAA;IACA,uBAAA;EC5IN;ED+IE;IACI,0BAAA;EC7IN;EDgJE;IACI,eAAA;IACA,iBAAA;EC9IN;AACF;ADiJA;EAEQ;IACI,uBAAA;EChJV;EDoJE;IACI,wBAAA;EClJN;EDqJE;IACI,uBAAA;IACA,wBAAA;IACA,wBAAA;ECnJN;EDsJE;IACI,uBAAA;IACA,wBAAA;IACA,wBAAA;ECpJN;EDuJE;IACI,uBAAA;IACA,wBAAA;IACA,wBAAA;ECrJN;EDwJE;IACI,0BAAA;ECtJN;ED0JM;IACI,WAAA;IACA,YAAA;ECxJV;ED4JE;IACI,wBAAA;IACA,uBAAA;IACA,wBAAA;EC1JN;ED6JE;IACI,uBAAA;IACA,uBAAA;IACA,wBAAA;EC3JN;AACF;AD8JA;EACI;IACI,kBAAA;IACA,oBAAA;EC5JN;ED+JE;IACI,SAAA;EC7JN;ED+JM;IACI,sCAAA;EC7JV;EDgKM;IACI,iBAAA;EC9JV;EDkKE;IACI,uBAAA;EChKN;EDkKM;IACI,gBAAA;IACA,mBAAA;EChKV;AACF;ADoKA;EACI;IACI,iBAAA;IACA,YAAA;IACA,qBAAA;IACA,+BAAA;EClKN;EDoKM;IACI,eAAA;IACA,kBAAA;IACA,mBAAA;EClKV;EDsKE;IACI,SAAA;IACA,eAAA;ECpKN;EDsKM;IACI,kBAAA;IACA,iBAAA;ECpKV;EDuKM;IACI,eAAA;IACA,gBAAA;ECrKV;EDwKM;IACI,WAAA;IACA,gBAAA;ECtKV;ED0KE;IACI,uBAAA;IACA,mBAAA;ECxKN;ED0KM;IACI,SAAA;ECxKV;ED2KM;IACI,WAAA;IACA,YAAA;IACA,mBAAA;ECzKV;ED4KM;IACI,kBAAA;EC1KV;ED6KM;IACI,kBAAA;IACA,iBAAA;EC3KV;ED8KM;IACI,0BAAA;IACA,QAAA;IACA,gBAAA;IACA,mBAAA;EC5KV;ED+KM;IACI,aAAA;EC7KV;EDgLM;IACI,gBAAA;EC9KV;EDkLE;IACI,kBAAA;EChLN;EDmLE;IACI,wBAAA;ECjLN;EDqLM;IACI,4BAAA;IACA,8BAAA;ECnLV;EDsLE;IACI,wBAAA;IAEA,gCAAA;ECpLN;EDsLE;IAEI,wBAAA;IAEA,gCAAA;ECrLN;EDyLM;IACI,0BAAA;ECvLV;ED0LM;IACI,wBAAA;IAEA,gCAAA;ECxLV;ED6LM;IACI,WAAA;IACA,YAAA;EC3LV;EDgMM;IACI,2BAAA;EC9LV;EDkME;IACI,gBAAA;EChMN;AACF;AA3vCA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AA6vCJ;AA3vCI;EACI;IACI,2BAAA;EA6vCV;EA3vCM;IACI,6BAAA;EA6vCV;EA3vCM;IACI,2BAAA;EA6vCV;AACF;AA1vCI;EACI,aAAA;AA4vCR;;AAxvCA;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;UAAA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;AA2vCJ;AAzvCI;EAbJ;IAcQ,kBAAA;IACA,eAAA;EA4vCN;AACF;;AAzvCA;EACI,kBAAA;EACA,mBAAA;AA4vCJ;AA1vCI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AA4vCR;AAzvCI;EACI,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AA2vCR;;AAvvCA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AA0vCJ;AAxvCI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AA0vCR;AAxvCQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AA0vCZ;AAvvCQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAyvCZ;AAvvCY;EACI;IAAW,wBAAA;EA0vCzB;EAzvCc;IAAM,2BAAA;EA4vCpB;EA3vCc;IAAM,0BAAA;EA8vCpB;AACF;AA3vCQ;EACI,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;AA6vCZ;AA3vCY;EACI;IACI,UAAA;IACA,4BAAA;EA6vClB;EA3vCc;IACI,UAAA;IACA,wBAAA;EA6vClB;AACF;AA1vCY;EACI,oCAAA;EACA,0CAAA;EACA,cAAA;AA4vChB;AAvvCI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAyvCR;AAvvCQ;EALJ;IAMQ,0BAAA;IACA,SAAA;EA0vCV;AACF;;AAtvCA;EACI,kBAAA;EACA,8BAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;AAyvCJ;AAvvCI;EACI,aAAA;AAyvCR;AAtvCI;EACI,yBAAA;EACA,2BAAA;EACA,qBAAA;AAwvCR;AArvCI;EACI,yBAAA;EACA,2BAAA;EACA,qBAAA;AAuvCR;AApvCI;EACI,yBAAA;EACA,2BAAA;EACA,qBAAA;AAsvCR;AAnvCI;EACI,yBAAA;EACA,2BAAA;EACA,qBAAA;AAqvCR;AAlvCI;EACI,qBAAA;AAovCR;AAjvCI;EACI,8BAAA;EACA,sCAAA;EACA,8CAAA;AAmvCR;AAhvCI;EACI,qBAAA;EACA,oCAAA;EACA,iCAAA;AAkvCR;AAhvCQ;EACI,8CAAA;AAkvCZ;AA9uCI;EACI,gBAAA;EACA,0DAAA;EACA,4BAAA;EACA,sCAAA;EACA,mBAAA;AAgvCR;AA7uCI;EACI,mBAAA;EACA,YAAA;EACA,aAAA;AA+uCR;AA7uCQ;EACI,mBAAA;AA+uCZ;;AA1uCA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AA6uCJ;AA3uCI;EACI,SAAA;EACA,mBAAA;AA6uCR;AA1uCI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;AA4uCR;AA1uCQ;EACI,cAAA;AA4uCZ;AAzuCQ;EACI,YAAA;AA2uCZ;AAxuCQ;EACI,WAAA;EACA,YAAA;AA0uCZ;;AAruCA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,kCAAA;AAwuCJ;AAtuCI;EACI;IACI,UAAA;IACA,2BAAA;EAwuCV;EAtuCM;IACI,UAAA;IACA,wBAAA;EAwuCV;AACF;AAruCI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AAuuCR;AAruCQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAuuCZ;AApuCQ;EACI,cAAA;AAsuCZ;AApuCY;EACI,uBAAA;EACA,oCAAA;AAsuChB;AAnuCY;EACI;IACI,kCAAA;IACA,UAAA;EAquClB;EAnuCc;IACI,mCAAA;EAquClB;EAnuCc;IACI,gCAAA;IACA,UAAA;EAquClB;AACF;;AA/tCA;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAkuCJ;AAhuCI;EACI,6DAAA;EACA,YAAA;EACA,8CAAA;AAkuCR;AAhuCQ;EACI,2BAAA;EACA,8CAAA;AAkuCZ;AA/tCQ;EACI,wBAAA;AAiuCZ;AA7tCI;EACI,qCAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AA+tCR;AA5tCI;EACI,oBAAA;EACA,mBAAA;AA8tCR;;AA1tCA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA6tCJ;AA3tCI;EACI,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oCAAA;AA6tCR;AA3tCQ;EACI,cAAA;EACA,4BAAA;EACA,iBAAA;AA6tCZ;;AAxtCA,2BAAA;AACA;EACI;IACI,mBAAA;EA2tCN;EAxtCE;IACI,eAAA;EA0tCN;AACF;AAvtCA;EACI;IACI,aAAA;EAytCN;EAttCE;IACI,kBAAA;EAwtCN;EArtCE;IACI,mBAAA;EAutCN;EArtCM;IACI,eAAA;EAutCV;EAptCM;IACI,eAAA;EAstCV;EAltCE;IACI,eAAA;EAotCN;EAltCM;IACI,eAAA;EAotCV;AACF;AAhtCA;EACI;IACI,UAAA;IACA,2BAAA;EAktCN;EAhtCE;IACI,UAAA;IACA,wBAAA;EAktCN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Red+Hat+Display:ital,wght@0,300..900;1,300..900&display=swap');\n\n* {\n    font-family: \"Red Hat Display\", sans-serif;\n}\n\nbody {\n    margin: 0;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    color: $text-color;\n    overscroll-behavior: none;\n    width: 100vw;\n    overflow-x: hidden;\n}\n\nul {\n    padding-left: 1rem;\n}\n\n.main-layout-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n\n    &--interview {\n        min-height: 100vh;\n        overflow: hidden;\n        background: #0a0c12;\n    }\n}\n\n.text-brand {\n    color: $brand-color;\n}\n\n.text-brand2 {\n    color: $brand2-color;\n}\n\n.text-right {\n    text-align: right;\n}\n\n// Placeholder styling is handled per-page in respective SCSS files\n\n.form-check-input:checked {\n    background-color: $brand-color;\n    border-color: $brand-color;\n}\n\n.form-check-input:focus {\n    box-shadow: 0 0 0 0.25rem rgba($brand-color, 0.25);\n}\n\n.header {\n    font-weight: 900;\n    font-size: 2rem;\n    line-height: 2.7rem;\n}\n\n.subheader {\n    font-weight: 600;\n    font-size: 1.6rem;\n}\n\n.title {\n    font-weight: 400;\n    font-size: 1.2rem;\n}\n\n.text-inactive {\n    color: #a0a9b1 !important;\n}\n\n.css-t3ipsp-control {\n    box-shadow: none !important;\n    border-color: $brand-color !important;\n}\n\n.css-t3ipsp-control:hover {\n    border-color: $brand-color !important;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.btn-brand {\n    background-color: $brand-color !important;\n    color: white !important;\n    padding-left: 25px !important;\n    padding-right: 25px !important;\n}\n\n.btn-outline-brand {\n    border-color: $brand-color !important;\n    color: $brand-color !important;\n    padding-left: 25px !important;\n    padding-right: 25px !important;\n}\n\n.btn-scroll-wrap{\n    position: fixed; \n    right: 30px;\n    bottom: 30px;\n    z-index: 2;\n    width: auto;\n    height: auto;\n\n    .btn-scroll{\n        cursor: pointer;\n        width: 50px;\n        height: 50px;\n        background-color: #fff;\n        border-radius: 50%;\n        text-align: center;\n        box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.40);\n        -webkit-box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.40);\n        -moz-box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.40);\n        margin: auto;\n        margin-bottom: 5px;\n        position: relative;\n\n        svg{\n            width: 20px;\n            height: 20px;\n            position: absolute;\n            left: 50%;\n            top: 50%;\n            transform: translate(-50%, -50%);\n            color: $brand-color;\n        }\n    }\n\n    .txt{\n        font-size: .7rem;\n        color: #5C5C5C;\n        text-align: center;\n    }\n}\n\n.outlet-wrapper {\n    padding-top: 106px;\n    flex: 1 1 auto;\n\n    &--interview {\n        padding-top: 0;\n        min-height: 100vh;\n    }\n\n    &--interview-fullscreen {\n        overflow: hidden;\n        background: #0a0c12;\n    }\n}\n\n\n@keyframes logoNav {\n    0% {\n        height: 80px;\n    }\n    100% {\n        height: 40px;\n    }\n}\n\n@keyframes logoNavIddle {\n    0% {\n        height: 40px;\n    }\n    100% {\n        height: 80px;\n    }\n}\n\n.navbar {\n    background: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(9.7px);\n    -webkit-backdrop-filter: blur(9.7px);\n\n    .logo {\n        height: 80px;\n    }\n\n    .nav-link {\n        font-weight: 600;\n        font-weight: bold;\n        color: #343a40e6;\n\n        &:hover {\n            color: $brand-color;\n        }\n\n        &.active {\n            color: $brand-color;\n        }\n    }\n\n    .btn-login {\n        background-color: $brand-color !important;\n        color: #fff !important;\n        padding: 6px 18px !important;\n        border-radius: 8px;\n        font-weight: 600;\n        margin-left: 10px;\n\n        &:hover {\n            background-color: darken($brand-color, 8%) !important;\n            color: #fff !important;\n        }\n    }\n\n    .navbar-toggler {\n        padding: 10px;\n    }\n}\n\n.naviddle {\n    .navbar {\n        .logo {\n            animation-duration: 0.5s;\n            animation-name: logoNavIddle;\n            animation-timing-function: ease-out;\n            height: 80px;\n        }\n    }\n}\n  \n.navresize {\n    .navbar {\n        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n        border: 1px solid rgba(255, 255, 255, 0.3);\n\n        .logo {\n            animation-duration: 0.5s;\n            animation-name: logoNav;\n            animation-timing-function: ease-out;\n            height: 40px;\n        }\n    }\n}\n\n// Profile Menu Styles\n.profile-menu-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n\n    .profile-picture {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        object-fit: cover;\n        border: 2px solid $brand-color;\n        transition: all 0.3s ease;\n\n        &:hover {\n            box-shadow: 0 2px 8px rgba(18, 183, 173, 0.3);\n            transform: scale(1.05);\n        }\n    }\n\n    .profile-dropdown {\n        position: absolute;\n        top: 100%;\n        right: 0;\n        background: white;\n        border-radius: 8px;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n        min-width: 150px;\n        margin-top: 8px;\n        z-index: 1000;\n        animation: slideDown 0.3s ease-out;\n\n        @keyframes slideDown {\n            from {\n                opacity: 0;\n                transform: translateY(-10px);\n            }\n            to {\n                opacity: 1;\n                transform: translateY(0);\n            }\n        }\n\n        .profile-dropdown__item {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            width: 100%;\n            padding: 12px 16px;\n            border: none;\n            background: none;\n            color: #333;\n            font-weight: 500;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            border-radius: 8px 8px 0 0;\n\n            &:hover {\n                background-color: #f0fffe;\n                color: $brand-color;\n            }\n\n            svg {\n                width: 18px;\n                height: 18px;\n            }\n        }\n\n        .logout-btn {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            width: 100%;\n            padding: 12px 16px;\n            border: none;\n            background: none;\n            color: #ff6b6b;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            border-radius: 8px;\n\n            &:hover {\n                background-color: #fff5f5;\n                color: #ff5252;\n            }\n\n            svg {\n                width: 18px;\n                height: 18px;\n            }\n        }\n    }\n}\n\n.main-content, .talent-content {\n    width: 100%;\n    height: calc(100vh - 60px);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n\n    .main-parallax-1 {\n        position: absolute;\n        bottom: -30px;\n        right: 0px;\n        width: 550px;\n        height: 550px;\n        z-index: 0;\n        background-image: url('../assets/img/bg-main-1-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n        z-index: 0;\n    }\n\n    .main-parallax-2 {\n        position: absolute;\n        bottom: 30px;\n        right: 0px;\n        width: 550px;\n        height: 550px;\n        z-index: 0;\n        background-image: url('../assets/img/bg-main-2-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n\n    .main-parallax-3 {\n        position: absolute;\n        bottom: 0px;\n        right: 0px;\n        width: 550px;\n        height: 550px;\n        z-index: 0;\n        background-image: url('../assets/img/bg-main-3-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n\n    .content-wrapper {\n        max-width: 550px;\n        z-index: 2;\n\n        .subtitle {\n            font-weight: 900;\n            color: $brand2-color;\n            font-size: 1.2rem;\n            text-transform: uppercase;\n        }\n    \n        .title {\n            font-weight: 900;\n            color: $brand-color;\n            font-size: 2.6rem;\n            margin-top: 15px;\n            line-height: 2.8rem;\n        }\n    \n        .desc {\n            margin-top: 15px;\n            font-size: 1rem;\n            font-weight: 600;\n        }\n    }\n}\n\n.talent-content {\n    height: calc(70vh);\n\n    .main-parallax-4 {\n        position: absolute;\n        bottom: -100px;\n        right: 0px;\n        width: 550px;\n        height: 550px;\n        z-index: 0;\n        background-image: url('../assets/img/bg-main-4-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n\n    .main-parallax-2 {\n        bottom: -100px;\n    }\n}\n\n.bg-brand-opacity {\n    background-color: #f1faf9;\n}\n\n.bg-brand {\n    background-color: $brand-color;\n}\n\n.text-wrap {\n    text-wrap: wrap !important;\n}\n\n.flex-1 {\n    min-width: 0;\n    flex: 1 !important;\n}\n\n.card {\n    border: 1px solid #eee;\n\n    &.no-border {\n        border-width: 0px !important;\n    }\n}\n\n.shadow {\n    box-shadow: -3px 3px 28px -4px rgba(148,148,148,0.4) !important;\n    -webkit-box-shadow: -3px 3px 28px -4px rgba(148,148,148,0.4) !important;\n    -moz-box-shadow: -3px 3px 28px -4px rgba(148,148,148,0.4) !important;\n}\n\n.slick-track,\n.slick-list {\n    width: 100%;\n    min-width: 100%;\n}\n\n.slick-dots li button {\n\n    &::before{\n        font-size: 18px;\n    }\n}\n\n.slick-dots li.slick-active button {\n\n    &::before{\n        color: $brand-color;\n    }\n}\n\n.about-us {\n    position: relative;\n    z-index: 2;\n\n    &::after{\n        content: \"\";\n        width: 200px;\n        height: 140px;\n        background-image: url(\"../assets/img/img-part-1.png\");\n        background-size: contain;\n        background-repeat: no-repeat;\n        position: absolute;\n        left: 0;\n        top: 0;\n    }\n\n    .about-us-image-wrapper {\n        width: 100%;\n        height: 100%;\n        position: relative;\n    }\n\n    .about-us-parallax-1 {\n        position: absolute;\n        top: 0;\n        left: -30px;\n        right: 0;\n        bottom: 0;\n        z-index: 0;\n        background-image: url('../assets/img/about-us-1.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n        z-index: 0;\n    }\n\n    .about-us-parallax-2 {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 0;\n        background-image: url('../assets/img/about-us-2.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n\n    .about-us-parallax-3 {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 0;\n        background-image: url('../assets/img/about-us-3.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n}\n\n.talent-list-wrapper {\n    position: relative;\n    z-index: 2;\n    background-color: #f1faf9;\n}\n\n.talent-list {\n    img {\n        width: 30%;\n        height: 30%;\n        border-radius: 10px;\n        object-fit: cover;\n    }\n}\n\ninput, textarea {\n    &:focus {\n        border-color: $brand-color !important;\n        box-shadow: none !important;\n        outline:none !important;\n    }\n}\n\n.daterangepicker td.in-range {\n    background-color: $bg-brand-color !important;\n}\n\n.daterangepicker td.available {\n    color: #0f172a;\n    font-weight: 600;\n    transition: background-color .18s ease, color .18s ease, box-shadow .18s ease;\n}\n\n.daterangepicker td.available:hover {\n    background-color: rgba(46, 196, 182, 0.14) !important;\n    color: $brand-color !important;\n    box-shadow: inset 0 0 0 1px rgba(46, 196, 182, 0.28);\n}\n\n.daterangepicker td.off.disabled,\n.daterangepicker td.disabled,\n.daterangepicker option.disabled {\n    color: #c3cdd8 !important;\n    background-color: #fff !important;\n    text-decoration: none !important;\n    opacity: 1;\n    cursor: not-allowed;\n}\n\n.daterangepicker .drp-buttons .btn-primary{\n    background-color: $brand-color;\n    border-color: $brand-color;\n}\n\n.daterangepicker td.active {\n    background-color: $brand-color !important;\n    color: #fff !important;\n    font-weight: 700;\n    box-shadow: 0 8px 20px rgba(46, 196, 182, 0.24);\n}\n\n.image-uploader-container{\n    width: 100%;\n    position: relative;\n    height: 100%;\n    border-radius: 8px;\n    overflow: hidden;\n    \n    .image-uploader-bg{\n        width: 100%;\n        background-size: cover;\n        background-position: center;\n        background-repeat: no-repeat;\n        height: 100%;\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: cover;\n        box-sizing: border-box;\n        background: $bg-brand-color;\n    \n    \n        &.singleback{\n            background-position: center;\n            background-repeat: no-repeat;\n            background-size: cover;\n            filter: blur(34px);\n            background: $bg-brand-color;\n        }   \n    }\n\n    img{\n        position: absolute;\n        height: 100%;\n        width: auto;\n        top: 0;\n        left: 50%;\n        transform: translateX(-50%);\n    }\n}\n\n.input-tag-wrapper {\n    .ReactTags__tags {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .ReactTags__tagInput {\n        flex: 1;\n\n        input {\n            width: 100%;\n            padding: 0.375rem 0.75rem;\n            display: block;\n            width: 100%;\n            font-size: 1rem;\n            font-weight: 400;\n            line-height: 1.5;\n            color: var(--bs-body-color);\n            appearance: none;\n            background-color: var(--bs-body-bg);\n            background-clip: padding-box;\n            border: var(--bs-border-width) solid var(--bs-border-color);\n            border-radius: var(--bs-border-radius);\n            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n            &:focus {\n                border-color: $brand-color !important;\n                box-shadow: none !important;\n                outline:none !important;\n            }\n        }\n\n    }\n  \n    .ReactTags__selected {\n        display: flex;\n        gap: 5px;\n        flex-wrap: wrap;\n    }\n  \n    .ReactTags__selected span.ReactTags__tag {\n        background: $brand-color;\n        color: white;\n        font-size: 12px;\n        display: flex;\n        padding: 5px;\n        border-radius: 3px;\n    }\n\n    .ReactTags__selected a.ReactTags__remove {\n        color: #aaa;\n        margin-left: 5px;\n        cursor: pointer;\n    }\n    \n    .ReactTags__remove {\n        border: none;\n        cursor: pointer;\n        background: none;\n        color: white;\n        margin-right: -5px;\n\n        svg {\n            width: 9px;\n            height: 9px;\n            margin-top: -3px;\n        }\n    }\n}\n\n.css-1p3m7a8-multiValue {\n    background-color: $brand-color !important;\n    color: #fff !important;\n\n    .css-9jq23d {\n        color: #fff !important;\n    }\n}\n\n.service-list {\n    .list {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 15px;\n        margin-bottom: 10px;\n\n        svg {\n            width: 1.8rem;\n            height: 1.8rem;\n            color: $brand2-color;\n        }\n\n        .desc {\n            font-weight: bold;\n            font-size: 1.3rem;\n        }\n    }\n}\n\n.arrow-service {\n    width: 40px;\n    height: 40px;\n    background-color: $brand-color;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n\n    &.disabled{\n        background-color: #fff;\n        border: 2px solid rgba($brand-color, 0.4);\n        cursor: default;\n\n        svg {\n            color: rgba($brand-color, 0.4);\n        }\n    }\n\n    svg {\n        color: #fff;\n        width: 20px;\n        height: 20px;\n    }\n}\n\n.service {\n    .bg-service {\n        width: 100%;\n        position: relative;\n\n        &::after {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: -25px;\n            height: 150px;\n            background-color: $brand2-color;\n            z-index: -1;\n            border-radius: 10px;\n        }\n    }\n}\n\n.product {\n    background-color: rgba($brand2-color, .2);\n    border-radius: 20px;\n    position: relative;\n\n    .video-parallax-2 {\n        position: absolute;\n        bottom: 300px;\n        right: -100px;\n        width: 350px;\n        height: 350px;\n        background-image: url('../assets/img/bg-main-2-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n        z-index: -1;\n    }\n\n    .video-parallax-3 {\n        position: absolute;\n        bottom: 150px;\n        left: -180px;\n        width: 350px;\n        height: 350px;\n        background-image: url('../assets/img/bg-main-3-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n        z-index: -1;\n    }\n}\n\n.video-wrapper{\n    border-radius: 20px;\n    overflow: hidden;\n    margin: auto;\n    \n    video {\n        width: 80%;\n        border-radius: 20px;\n        height: auto;\n        overflow: hidden;\n    }\n}\n\n.partner-list {\n    img {\n        width: 60%;\n        height: 80px;\n        object-fit: contain;\n        margin: auto;\n    }\n}\n\n.partner-logo-wrapper {\n    height: 80px;\n    display: flex;\n    justify-content: center;\n\n    img{\n        height: 100%;\n        width: 60%;\n        object-fit: contain;\n    }\n}\n\n.bg-call-us {\n    width: 100%;\n    height: 250px;\n    background-image: url(\"../assets/img/bg-image.png\");\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.company-detail {\n    margin-top: -150px;\n}\n\n.form-detail {\n    margin-top: -70px;\n}\n\n.for-talent-wrapper {\n    background-color: $brand-color;\n    color: #fff;\n    overflow: hidden;\n\n    hr {\n        height: 2px;\n        background: #fff !important;\n    }\n}\n\n.img-for-talent {\n    width: 100%;\n    height: 100%;\n    background-image: url(\"../assets/img/image11.png\");\n    background-size: cover;\n    background-position: center;\n}\n\n.footer {\n    background-color: $brand-color;\n    border-top: 1px solid #fff;\n\n    .hr {\n        width: 100%;\n        height: 1px;\n        background-color: #fff;\n    }\n\n    a {\n        color: #fff;\n    }\n}\n\n.thank-container {\n    background-image: url(\"../assets/img/bg-thanks.png\");\n    background-size: cover;\n    background-position: 50% center;\n    background-repeat: no-repeat;\n    min-height: 100vh;\n    height: auto;\n    margin-top: -106px;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    padding: clamp(132px, 16vh, 180px) 0 clamp(42px, 7vh, 72px);\n\n    .container {\n        width: min(100%, clamp(600px, 42vw, 700px));\n        max-width: none;\n    }\n}\n\n.thank-shell {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: clamp(16px, 1.8vh, 20px);\n    width: 100%;\n    max-width: min(100%, 680px);\n    margin: 0 auto;\n    transform: translateX(clamp(-20px, -1.15vw, -10px));\n\n    &__eyebrow {\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n        padding: 8px 14px;\n        border-radius: 999px;\n        background: rgba(18, 184, 134, 0.12);\n        color: $brand-color;\n        font-size: 0.92rem;\n        font-weight: 700;\n\n        svg {\n            width: 16px;\n            height: 16px;\n        }\n    }\n\n    &__heading {\n        font-size: clamp(2.35rem, 3.4vw, 4rem);\n        font-weight: 900;\n        line-height: 1.08;\n        margin: 0;\n        max-width: 100%;\n        text-wrap: balance;\n    }\n\n    &__subtitle {\n        font-size: clamp(1rem, 1.15vw, 1.1rem);\n        line-height: 1.65;\n        color: #495057;\n        max-width: 34rem;\n        margin: 0;\n        text-wrap: balance;\n    }\n\n    &__secondary-cta {\n        margin-top: 4px;\n        min-width: 220px;\n        border-width: 1.5px !important;\n        background: rgba(255, 255, 255, 0.82) !important;\n    }\n}\n\n.thank-next-step-card {\n    width: 100%;\n    margin-top: 8px;\n    padding: clamp(24px, 2.4vw, 30px) clamp(22px, 2.6vw, 30px) clamp(22px, 2.1vw, 26px);\n    border-radius: 24px;\n    background: rgba(255, 255, 255, 0.94);\n    border: 1px solid rgba(18, 184, 134, 0.16);\n    box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n    backdrop-filter: blur(8px);\n    text-align: left;\n\n    &__badge {\n        display: inline-flex;\n        align-items: center;\n        min-height: 32px;\n        padding: 6px 12px;\n        border-radius: 999px;\n        background: rgba(34, 197, 94, 0.12);\n        color: #0f9b6c;\n        font-size: 0.84rem;\n        font-weight: 800;\n        margin-bottom: 18px;\n    }\n\n    &__header {\n        display: flex;\n        align-items: flex-start;\n        gap: clamp(14px, 1.4vw, 18px);\n    }\n\n    &__icon {\n        width: 54px;\n        height: 54px;\n        border-radius: 16px;\n        background: linear-gradient(135deg, rgba(18, 184, 134, 0.16), rgba(255, 196, 62, 0.18));\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        color: $brand-color;\n        flex-shrink: 0;\n\n        svg {\n            width: 24px;\n            height: 24px;\n        }\n    }\n\n    &__copy {\n        flex: 1;\n        min-width: 0;\n    }\n\n    &__title {\n        font-size: clamp(1.34rem, 1.45vw, 1.52rem);\n        font-weight: 800;\n        color: #102a43;\n        margin-bottom: 8px;\n        line-height: 1.22;\n    }\n\n    &__description {\n        font-size: clamp(0.98rem, 1vw, 1.02rem);\n        line-height: 1.65;\n        color: #52606d;\n        margin: 0;\n    }\n\n    &__meta {\n        display: grid;\n        grid-template-columns: repeat(3, minmax(148px, 1fr));\n        gap: 10px;\n        margin-top: 22px;\n        margin-bottom: 22px;\n    }\n\n    &__meta-item {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        min-height: 52px;\n        padding: 12px 14px;\n        border-radius: 16px;\n        background: #f8fbfc;\n        border: 1px solid rgba(148, 163, 184, 0.18);\n        color: #334e68;\n        font-size: 0.92rem;\n        line-height: 1.45;\n\n        svg {\n            width: 18px;\n            height: 18px;\n            flex-shrink: 0;\n            color: $brand-color;\n        }\n    }\n\n    &__cta {\n        width: 100%;\n        min-height: 54px;\n        border-radius: 16px !important;\n        font-size: 1rem !important;\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n        box-shadow: 0 12px 30px rgba(25, 135, 84, 0.2);\n\n        svg {\n            width: 18px;\n            height: 18px;\n        }\n    }\n}\n\n.desktop-only {\n    display: block;\n}\n\n.equal-height-slider .slick-track {\n  display: flex;\n  align-items: stretch;\n}\n\n.equal-height-slider .slick-slide {\n  height: inherit;\n}\n\n\n.problemsolve-wrapper {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch; /* Key property */\n    border-radius: 15px;\n    overflow: hidden;\n\n    ul {\n        font-size: 1.3rem;\n    }\n\n    .problem {\n        flex: 1;\n        background-color: #f8d7da;\n        color: #721c24;\n        padding: 10px 20px;\n        line-height: 2.5rem;\n    }\n\n    .solve {\n        flex: 1.4;\n        background-color: #d4edda;\n        color: #155724;\n        padding: 10px 20px 10px 70px;\n        line-height: 2.5rem;\n    }\n}\n\n.bot-wa {\n  position: fixed;\n  z-index: 9;\n  bottom: 6px;\n  right: 0px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n\n  .img-bot {\n    width: 100px;\n  }\n\n  .wa-bubble{\n    position: relative;\n    background-color: #ffffff;\n    padding: 8px 14px;\n    border-radius: 30px;\n    box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.60);\n    -webkit-box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.60);\n    -moz-box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.60);\n    font-weight: 800;\n    font-size: 15px;\n    max-width: 170px;\n    line-height: 1.4;\n    display: flex;\n    flex-direction: row;\n    margin-top: -10px;\n    align-items: center;\n\n    &::after{\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      right: -5px;\n      width: 12px;\n      height: 12px;\n      background-color: #ffffff;\n      transform: translateY(-50%) rotate(45deg);\n      box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.18);\n    }\n\n    .wa-icon {\n      width: 34px;\n      height: 34px;\n      flex-shrink: 0;\n    }\n  }\n}\n\n@media (max-width: 820px) {\n  body {\n    width: 100%;\n  }\n\n  .headerMain {\n    .navbar {\n      .container {\n        width: 100%;\n        max-width: 100%;\n        padding-left: 16px;\n        padding-right: 16px;\n      }\n\n      .navbar-brand {\n        flex: 0 0 auto;\n        margin-right: 12px;\n      }\n\n      .navbar-toggler {\n        flex: 0 0 auto;\n        margin-left: auto;\n      }\n    }\n  }\n\n  .bot-wa {\n    right: 4px;\n    bottom: 4px;\n\n    .wa-bubble {\n      display: none;\n    }\n\n    .img-bot {\n      width: 58px;\n      height: auto;\n    }\n  }\n}\n\n@media (max-width: 360px) {\n  .headerMain {\n    .navbar {\n      .container {\n        padding-left: 10px;\n        padding-right: 10px;\n      }\n    }\n  }\n}\n\n/* ==== START MEDIA QUERY ====*/\n@media only screen and (min-width: 991px ) and (max-width: 1400px ) {\n    .main-parallax-1 {\n        width: 39vw !important;\n        height: 39vw !important;\n    }\n\n    .main-parallax-2 {\n        width: 39vw !important;\n        height: 39vw !important;\n    }\n\n    .main-parallax-3 {\n        width: 39vw !important;\n        height: 39vw !important;\n    }\n\n    .content-wrapper {\n        max-width: 40vw !important;\n    }\n\n    .app-talent.container {\n        max-width: 100%;\n        margin-left: 3rem;\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .navbar {\n        .logo {\n            height: 50px !important;\n        }\n    }\n\n    .desktop-only {\n        display: none !important;\n    }\n\n    .main-parallax-1 {\n        width: 500px !important;\n        height: 500px !important;\n        right: -220px !important;\n    }\n\n    .main-parallax-2 {\n        width: 500px !important;\n        height: 500px !important;\n        right: -220px !important;\n    }\n\n    .main-parallax-3 {\n        width: 500px !important;\n        height: 500px !important;\n        right: -220px !important;\n    }\n\n    .content-wrapper {\n        max-width: 50vw !important;\n    }\n\n    .video-wrapper{\n        video {\n            width: 100%;\n            height: auto;\n        }\n    }\n\n    .video-parallax-2 {\n        right: -180px !important;\n        width: 300px !important;\n        height: 300px !important;\n    }\n\n    .video-parallax-3 {\n        left: -280px !important;\n        width: 350px !important;\n        height: 350px !important;\n    }\n}\n\n@media (max-height: 860px) and (min-width: 1024px) {\n    .thank-container {\n        padding-top: 116px;\n        padding-bottom: 36px;\n    }\n\n    .thank-shell {\n        gap: 14px;\n\n        &__heading {\n            font-size: clamp(2.15rem, 3vw, 3.2rem);\n        }\n\n        &__subtitle {\n            line-height: 1.58;\n        }\n    }\n\n    .thank-next-step-card {\n        padding: 22px 22px 20px;\n\n        &__meta {\n            margin-top: 18px;\n            margin-bottom: 18px;\n        }\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .thank-container {\n        min-height: 100vh;\n        height: auto;\n        padding: 120px 0 32px;\n        background-position: center top;\n\n        .container {\n            max-width: 100%;\n            padding-left: 20px;\n            padding-right: 20px;\n        }\n    }\n\n    .thank-shell {\n        gap: 14px;\n        transform: none;\n\n        &__heading {\n            font-size: 1.95rem;\n            line-height: 1.18;\n        }\n\n        &__subtitle {\n            font-size: 1rem;\n            line-height: 1.6;\n        }\n\n        &__secondary-cta {\n            width: 100%;\n            min-height: 48px;\n        }\n    }\n\n    .thank-next-step-card {\n        padding: 22px 18px 18px;\n        border-radius: 20px;\n\n        &__header {\n            gap: 14px;\n        }\n\n        &__icon {\n            width: 48px;\n            height: 48px;\n            border-radius: 14px;\n        }\n\n        &__title {\n            font-size: 1.22rem;\n        }\n\n        &__description {\n            font-size: 0.96rem;\n            line-height: 1.62;\n        }\n\n        &__meta {\n            grid-template-columns: 1fr;\n            gap: 8px;\n            margin-top: 18px;\n            margin-bottom: 18px;\n        }\n\n        &__meta-item {\n            min-height: 0;\n        }\n\n        &__cta {\n            min-height: 50px;\n        }\n    }\n\n    .text-center-mobile {\n        text-align: center;\n    }\n\n    .desktop-only {\n        display: none !important;\n    }\n\n    .main-content {\n        .title{\n            font-size: 1.5rem !important;\n            line-height: 1.8rem !important;\n        }\n    }\n    .main-parallax-1{\n        right: -250px !important;\n        -webkit-transform: scaleX(-1) !important;\n        transform: scaleX(-1) !important;\n    }\n    .main-parallax-2, .main-parallax-3 {\n        // display: none;\n        right: -350px !important;\n        -webkit-transform: scaleX(-1) !important;\n        transform: scaleX(-1) !important;\n    }\n\n    .talent-content {\n        .content-wrapper {\n            max-width: 70vw !important;\n        }\n\n        .main-parallax-4{\n            right: -220px !important;\n            -webkit-transform: scaleX(-1) !important;\n            transform: scaleX(-1) !important;\n        }\n    }\n\n    .video-wrapper{\n        video {\n            width: 100%;\n            height: auto;\n        }\n    }\n\n    .for-talent-wrapper {\n        .ms-5 {\n            margin-left: 0px !important;\n        }\n    }\n\n    .form-detail {\n        margin-top: 40px;\n    }\n}\n","@import './variables';\n@import './theme';\n\n.register-container {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #ffffff;\n    padding: 20px;\n    position: relative;\n\n    @keyframes gradient {\n        0% {\n            background-position: 0% 50%;\n        }\n        50% {\n            background-position: 100% 50%;\n        }\n        100% {\n            background-position: 0% 50%;\n        }\n    }\n\n    &::before {\n        content: none;\n    }\n}\n\n.register-container .register-card {\n    width: 100%;\n    max-width: 500px;\n    background: #ffffff;\n    backdrop-filter: none;\n    border-radius: 16px;\n    border: 1px solid #e2e8f0;\n    padding: 50px 40px;\n    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.1);\n    animation: slideUp 0.8s ease-out;\n    position: relative;\n    z-index: 10;\n\n    @media (max-width: 480px) {\n        padding: 40px 25px;\n        max-width: 100%;\n    }\n}\n\n.register-container .register-header {\n    text-align: center;\n    margin-bottom: 40px;\n\n    h1 {\n        font-size: 32px;\n        font-weight: 700;\n        color: #0b2540;\n        margin: 0 0 10px 0;\n        text-shadow: none;\n        letter-spacing: -0.5px;\n    }\n\n    p {\n        font-size: 14px;\n        color: #54708b;\n        margin: 0;\n        font-weight: 500;\n    }\n}\n\n.register-container .register-form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n\n    .form-group {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        label {\n            font-size: 14px;\n            font-weight: 600;\n            color: #17324d;\n            text-shadow: none;\n        }\n\n        .error-message {\n            font-size: 12px;\n            color: #ff6b6b;\n            font-weight: 500;\n            margin-top: 4px;\n            animation: shake 0.3s ease-in-out;\n\n            @keyframes shake {\n                0%, 100% { transform: translateX(0); }\n                25% { transform: translateX(-5px); }\n                75% { transform: translateX(5px); }\n            }\n        }\n\n        .alert {\n            padding: 14px 16px;\n            border-radius: 12px;\n            margin-bottom: 20px;\n            font-size: 14px;\n            font-weight: 500;\n            animation: slideDown 0.3s ease-out;\n\n            @keyframes slideDown {\n                from {\n                    opacity: 0;\n                    transform: translateY(-10px);\n                }\n                to {\n                    opacity: 1;\n                    transform: translateY(0);\n                }\n            }\n\n            &.alert-error {\n                background: rgba(255, 107, 107, 0.2);\n                border: 1px solid rgba(255, 107, 107, 0.5);\n                color: #ff6b6b;\n            }\n        }\n    }\n\n    .form-row {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 20px;\n\n        @media (max-width: 480px) {\n            grid-template-columns: 1fr;\n            gap: 16px;\n        }\n    }\n}\n\n.register-container .form-input {\n    padding: 14px 16px;\n    background: #ffffff !important;\n    border: 1.5px solid #d7e0e8;\n    border-radius: 12px;\n    font-size: 14px;\n    color: #102a43 !important;\n    font-family: inherit;\n    transition: all 0.3s ease;\n    outline: none;\n\n    &::-ms-reveal {\n        display: none;\n    }\n\n    &::placeholder {\n        color: #89a0b7 !important;\n        font-weight: 500 !important;\n        opacity: 1 !important;\n    }\n\n    &::-webkit-input-placeholder {\n        color: #89a0b7 !important;\n        font-weight: 500 !important;\n        opacity: 1 !important;\n    }\n\n    &::-moz-placeholder {\n        color: #89a0b7 !important;\n        font-weight: 500 !important;\n        opacity: 1 !important;\n    }\n\n    &:-ms-input-placeholder {\n        color: #89a0b7 !important;\n        font-weight: 500 !important;\n        opacity: 1 !important;\n    }\n\n    &::-moz-placeholder {\n        opacity: 1 !important;\n    }\n\n    &:focus {\n        background: #ffffff !important;\n        border-color: rgba(18, 183, 173, 0.65);\n        box-shadow: 0 0 0 3px rgba(18, 183, 173, 0.14);\n    }\n\n    &.error {\n        border-color: #ff6b6b;\n        background: rgba(255, 107, 107, 0.1);\n        animation: shake 0.3s ease-in-out;\n\n        &:focus {\n            box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.2);\n        }\n    }\n\n    select {\n        appearance: none;\n        background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23ffffff' d='M10.293 3.293L6 7.586 1.707 3.293A1 1 0 00.293 4.707l5 5a1 1 0 001.414 0l5-5a1 1 0 10-1.414-1.414z'%3E%3C/path%3E%3C/svg%3E\");\n        background-repeat: no-repeat;\n        background-position: right 12px center;\n        padding-right: 36px;\n    }\n\n    option {\n        background: #667eea;\n        color: white;\n        padding: 10px;\n\n        &:hover {\n            background: #764ba2;\n        }\n    }\n}\n\n.register-container .password-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n\n    .form-input {\n        flex: 1;\n        padding-right: 48px;\n    }\n\n    .password-toggle {\n        position: absolute;\n        right: 12px;\n        bottom: 12px;\n        background: none;\n        border: none;\n        color: #64748b;\n        cursor: pointer;\n        font-size: 16px;\n        padding: 6px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all 0.2s ease;\n        line-height: 1;\n\n        &:hover {\n            color: #0d8a84;\n        }\n\n        &:active {\n            opacity: 0.8;\n        }\n\n        svg {\n            width: 16px;\n            height: 16px;\n        }\n    }\n}\n\n.register-container .password-criteria {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 12px 16px;\n    background: #f8fafc;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n    margin-top: 8px;\n    animation: slideDown 0.3s ease-out;\n\n    @keyframes slideDown {\n        from {\n            opacity: 0;\n            transform: translateY(-8px);\n        }\n        to {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n    .criteria-item {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 12px;\n        color: #64748b;\n        transition: all 0.3s ease;\n\n        .criteria-icon {\n            width: 14px;\n            height: 14px;\n            stroke-width: 3;\n            color: #94a3b8;\n            flex-shrink: 0;\n        }\n\n        &.met {\n            color: #17324d;\n            \n            .criteria-icon {\n                color: rgba(34, 197, 94, 1);\n                animation: checkBounce 0.5s ease-out;\n            }\n\n            @keyframes checkBounce {\n                0% {\n                    transform: scale(0) rotate(-45deg);\n                    opacity: 0;\n                }\n                50% {\n                    transform: scale(1.2) rotate(10deg);\n                }\n                100% {\n                    transform: scale(1) rotate(0deg);\n                    opacity: 1;\n                }\n            }\n        }\n    }\n}\n\n.register-container .submit-button {\n    padding: 14px 16px;\n    border: none;\n    border-radius: 12px;\n    font-size: 16px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    margin-top: 8px;\n\n    &.active {\n        background: linear-gradient(135deg, #12b7ad 0%, #0d8a84 100%);\n        color: white;\n        box-shadow: 0 4px 15px rgba(18, 183, 173, 0.3);\n\n        &:hover {\n            transform: translateY(-2px);\n            box-shadow: 0 6px 20px rgba(18, 183, 173, 0.4);\n        }\n\n        &:active {\n            transform: translateY(0);\n        }\n    }\n\n    &.disabled {\n        background: rgba(142, 161, 180, 0.28);\n        color: rgba(23, 50, 77, 0.48);\n        cursor: not-allowed;\n        box-shadow: none;\n        transform: none;\n    }\n\n    &:disabled {\n        pointer-events: auto;\n        cursor: not-allowed;\n    }\n}\n\n.register-container .login-link {\n    text-align: center;\n    margin-top: 24px;\n    font-size: 14px;\n    color: #54708b;\n\n    a {\n        color: #0d8a84;\n        font-weight: 600;\n        text-decoration: none;\n        transition: all 0.2s ease;\n        border-bottom: 2px solid transparent;\n\n        &:hover {\n            color: #0a726d;\n            border-bottom-color: #0a726d;\n            text-shadow: none;\n        }\n    }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .register-card {\n        border-radius: 16px;\n    }\n\n    .register-header h1 {\n        font-size: 28px;\n    }\n}\n\n@media (max-width: 500px) {\n    .register-container {\n        padding: 16px;\n    }\n\n    .register-card {\n        padding: 32px 20px;\n    }\n\n    .register-header {\n        margin-bottom: 32px;\n\n        h1 {\n            font-size: 24px;\n        }\n\n        p {\n            font-size: 13px;\n        }\n    }\n\n    .form-input {\n        font-size: 16px; // Prevents zoom on iOS\n\n        &::placeholder {\n            font-size: 13px;\n        }\n    }\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n","$brand-color: #12b7ad !default;\n$brand2-color: #F7C154 !default;\n$bg-brand-color: #cce8e6 !default;\n$text-color: #31353bcf !default;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
